import { Model } from 'vue-models'
import DateTime from '../types/DateTime'
import TextField from '../types/TextField'
import PortModel from '../port'

export default class ConventionalStage extends Model {
  static defaults () {
    return {
      name: 'stage',
      computed: {
        __str__ () { return `${this.port.locode} (${this.arrival_planned})` }
      }
    }
  }
  static schema () {
    return {
      id: { type: Number },
      port: { type: PortModel },
      arrival_planned: { type: DateTime },
      arrival_actual: { type: DateTime },
      arrival_detected: { type: DateTime },
      arrival_predicted: { type: DateTime },
      departure_planned: { type: DateTime },
      departure_actual: { type: DateTime },
      departure_detected: { type: DateTime },
      departure_predicted: { type: DateTime },
      type: { type: TextField },
      source: { type: TextField },
      previous_stage: {type: Number}
    }
  }
}



// WEBPACK FOOTER //
// ./src/models/conventional/stage.js